import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const CONTENTS = {
  nickname: 'PRODUCTS.CONTENTS.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.25', value: '25000' }
        ]
      }
    },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'INSURANCE_INFO' },
    { name: 'objectZipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'contentMobileCoverType', key: 'MOBILE_COVER_TYPE', group: 'OBJECT_INFO' },
    { name: 'contentBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO' },
    { name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAlarmBurglar', key: 'HOUSE_SM_ALARM_BURGAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    }
  ],
  icon:'contents'
};
